import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, clearToken, saveToken } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(null);
      return null;
    }
  }, []);

  useEffect(() => {
    // If returning from OAuth callback, skip /me — AuthCallback will handle
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    refresh().finally(() => setLoading(false));
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    saveToken(data.token);
    setUser(data.user);
    return data.user;
  };
  const register = async (email, password, name, refCode = null) => {
    const body = { email, password, name };
    if (refCode) body.ref_code = refCode;
    const { data } = await api.post("/auth/register", body);
    saveToken(data.token);
    setUser(data.user);
    return data.user;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); }
    catch (err) { console.debug("[auth] logout request failed (clearing state anyway)", err); }
    clearToken();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refresh, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}
